// Получение данных, зависимых от роутера (TODO везде бы использовать)
import curry from 'ramda/es/curry';
import path from 'ramda/es/path';
import prop from 'ramda/es/prop';
import pipe from 'ramda/es/pipe';
import pickAll from 'ramda/es/pickAll';

import { replaceLast, replaceLastN } from 'app/common/lib/path';
import { history } from 'app/store';

// props первым параметром !!!
// TODO --- убрать
export const getStudentId = props => (
  (props.params && props.params.id) || null
);

export const getDate = props => (
  (props.params && props.params.date) || null
);

export const getPathName = props => (
  (props.location && props.location.pathname) || null
);
// TODO --- убрать


const getParam = curry((name, props) => path(['params', name], props));
const getAllParams = curry((arrPrams, props) => pipe(
  path(['params']),
  pickAll(arrPrams)
)(props));

const router = {
  locationReplace: (n) => {
    const location = history.getCurrentLocation();
    const pathname = prop('pathname', location);
    const steps = Math.abs(n);
    if (steps > 1) {
      history.push(replaceLastN(pathname, steps));
      return;
    }
    history.push(replaceLast(pathname));
  },

  push: history.push,

  /* use: router.getAllParams(['id', 'type'], props) */
  getAllParams, // в приоритете использовать это

  getParam,

  getField: getParam('field'),
};

export { router };
